import React from 'react';
import { TeamMemberCardProps } from './TeamMemberCard.types';
import {
  CardContainer,
  StyledAvatar,
  InfoContainer,
  StyledTitle,
  StyledText,
  SocialMediaSpace,
} from './TeamMemberCard.styles';
import SocialMedia from '../SocialMedia/SocialMedia';
import defaultPic from '../../assets/avatars/default_pic.png';
import { useI18n } from '../../hooks/useI18n';

const TeamMemberCard: React.FC<TeamMemberCardProps> = React.memo(
  ({ picture, name, role, socialMedia }) => {
    const { t } = useI18n();
    const imageSrc = picture || defaultPic;

    return (
      <CardContainer aria-label={t('accessibility.teamMemberProfile', { name, role })}>
        <StyledAvatar
          shape="square"
          size={170}
          src={imageSrc}
          alt={t('accessibility.teamMemberAvatar', { name })}
        />
        <InfoContainer>
          <StyledTitle level={3}>{name}</StyledTitle>
          <StyledText>{role}</StyledText>
          <SocialMediaSpace size={12}>
            {socialMedia.map((social, index) => (
              <SocialMedia
                key={`${social.socialMedia}-${index}`}
                platform={social.socialMedia}
                url={social.url}
                size="small"
              />
            ))}
          </SocialMediaSpace>
        </InfoContainer>
      </CardContainer>
    );
  },
);

TeamMemberCard.displayName = 'TeamMemberCard';

export default TeamMemberCard;
